<div class="app-container">
  <!--  <page-header [title]="isCreationModeEnabled ? 'purchase.new' : ('purchase.detail' | translate) + ' ' + purchaseOrder?.externalReference">-->
  <page-header [title]="isCreationModeEnabled ? 'purchase.new' : purchaseOrder?.externalReference">
    <ng-container *ngIf="!loading && !isCreationModeEnabled" class="custom-title">
      <!--      <div class="status-div margin-left" [ngClass]="'status-' + purchaseOrder?.status?.id" [title]="purchaseOrder?.status?.name | translate">-->
      <!--        {{ purchaseOrder?.status?.name | translate }}-->
      <!--      </div>-->
    </ng-container>
    <ng-container class="header-button">
      <btn
        *ngIf="isEditModeEnabled"
        [label]="'save'"
        [title]="'save' | translate"
        [classes]="['btn-first']"
        [icon]="'far-check'"
        [spinnerClassesString]="'spinner-white'"
        [btnType]="'submit'"
        (click)="create()"
        [btnDisabled]="!(purchaseOrderInfo.supplier && purchaseOrderInfo.depot)"
        [dataCyAttribute]="'create-purchase-order-button'"
      ></btn>
      <div *ngIf="isEditModeEnabled" class="info-text-price d-flex align-items-center mt-0">
        <p class="m-0">
          {{ 'price.info-text-1' | translate }}
          <br />
          {{ 'price.info-text-2' | translate }}
        </p>
        <i class="fal fa-info-circle"></i>
      </div>
      <dropdown
        *ngIf="purchaseOrder?.id > 0 && purchaseOrder?.status?.id !== 'stocked' && !isEditModeEnabled"
        [icon]="'fas-chevron-down'"
        [label]="'purchase-order.stock.dropdown-label'"
        [items]="[
          { action: 'stockUp', label: 'purchase-order.stock.all', isSelected: false },
          { action: 'stockUpInMobileApp', label: 'purchase-order.stock.all.mobile', isSelected: false },
        ]"
        [isArrowHidden]="true"
        [autoClose]="true"
        [classes]="['mr-2', 'float-right', 'custom-dropdown']"
        [theme]="'first'"
        (onResult)="stockUpAction($event)"
      ></dropdown>
      <btn
        *ngIf="canEdit && !isCreationModeEnabled && !isEditModeEnabled && purchaseOrder?.status?.id === 'new'"
        [label]="'purchase-order.delete'"
        [title]="'purchase-order.delete' | translate"
        [classes]="['btn-third', 'mr-2', 'float-right']"
        [isLoading]="loading"
        [icon]="'far-trash-alt'"
        (onEvent)="delete()"
        data-cy="delete-purchase-order"
      ></btn>
      <btn
        *ngIf="
          canEdit &&
          !isEditModeEnabled &&
          purchaseOrder?.status?.id !== 'stocked' &&
          purchaseOrder?.status?.id !== 'cancelled'
        "
        [label]="'purchase-order.edit'"
        [title]="'purchase-order.edit' | translate"
        [classes]="['btn-third', 'mr-2', 'float-right']"
        [isLoading]="loading"
        [icon]="'far-pencil'"
        (onEvent)="isEditModeEnabled = !isEditModeEnabled"
        data-cy="edit-purchase-order"
      ></btn>
      <dropdown
        *ngIf="purchaseOrder?.id > 0 && !isEditModeEnabled"
        [icon]="'fas-chevron-down'"
        [label]="'purchase-order.export.dropdown-label'"
        [items]="[
          { action: 'excelUrl', label: 'purchase-order.export.excelUrl', isSelected: false },
          { action: 'excelWOPricesUrl', label: 'purchase-order.export.excelWOPricesUrl', isSelected: false },
          { action: 'pdfUrl', label: 'purchase-order.export.pdfUrl', isSelected: false },
          { action: 'pdfWOPricesUrl', label: 'purchase-order.export.pdfWOPricesUrl', isSelected: false },
        ]"
        [isArrowHidden]="false"
        [autoClose]="true"
        [classes]="['mr-2', 'float-right custom-dropdown']"
        [theme]="'third'"
        (onResult)="export($event)"
      ></dropdown>
    </ng-container>
    <ng-container class="back-button">
      <btn
        [label]="'back'"
        [title]="'back' | translate"
        [isBackButton]="true"
        [classes]="['btn-third', 'float-right', 'mr-2']"
        [icon]="'far-arrow-left'"
        (onEvent)="navigateBack()"
      ></btn>
    </ng-container>
  </page-header>
  <section class="content">
    <nav class="tab-container" type="pills" *ngIf="purchaseOrderId > 0">
      <ul role="tablist" class="nav nav-pills">
        <li class="nav-item product-tab-heading">
          <div
            (click)="activeTab = 'common'"
            (keyup)="activeTab = 'common'"
            tabindex="0"
            [ngClass]="activeTab === 'common' ? 'active' : ''"
            class="nav-link"
          >
            {{ 'purchase-orders.tab.common' | translate }}
          </div>
        </li>
        <li class="nav-item product-tab-heading">
          <div
            (click)="activeTab = 'pmps'"
            (keyup)="activeTab = 'pmps'"
            tabindex="0"
            [ngClass]="activeTab === 'pmps' ? 'active' : ''"
            class="nav-link"
          >
            {{ 'purchase-orders.tab.pmps' | translate }}
          </div>
        </li>
      </ul>
    </nav>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
        <div *ngIf="activeTab === 'common'">
          <div class="row" *ngIf="!isEditModeEnabled">
            <div class="col-12 col-md-6 d-flex">
              <div class="card info-card w-100">
                <div>
                  <h3 class="card-title mb-2">
                    {{ 'info' | translate }}
                  </h3>
                </div>
                <div class="table-responsive">
                  <table class="table m-0" *ngIf="purchaseOrder?.id > 0">
                    <tbody>
                      <tr>
                        <td class="pl-0 card-subheading no-hover">
                          {{ 'purchaseOrder.externalReference' | translate }}
                        </td>
                        <td class="text-right no-hover">
                          {{ purchaseOrder.externalReference }}
                        </td>
                      </tr>
                      <tr>
                        <td class="pl-0 card-subheading no-hover">
                          {{ 'dateCreatedLong' | translate }}
                        </td>
                        <td class="text-right no-hover">
                          {{ purchaseOrder.created | fmtDate: 'dd.MM.yyyy' }}
                        </td>
                      </tr>
                      <tr>
                        <td class="pl-0 card-subheading no-hover">
                          {{ 'createdBy' | translate }}
                        </td>
                        <td class="text-right no-hover">
                          {{ purchaseOrder.createdBy?.name }}
                        </td>
                      </tr>
                      <tr>
                        <td class="pl-0 card-subheading no-hover">
                          {{ 'status' | translate }}
                        </td>
                        <td class="text-right no-hover">
                          {{ 'purchaseOrderStatus.' + purchaseOrder?.status?.id | translate }}
                        </td>
                      </tr>
                      <tr>
                        <td class="pl-0 card-subheading no-hover">{{ 'purchase.depot-to' | translate }}</td>
                        <td class="text-right no-hover">
                          {{ purchaseOrder.depot?.name }}
                        </td>
                      </tr>
                      <tr>
                        <td class="pl-0 card-subheading no-hover">{{ 'supplier' | translate }}</td>
                        <td class="text-right no-hover">
                          {{ purchaseOrder.supplier?.name }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="card info-card w-100" *ngIf="purchaseOrderInfo.note">
                <div>
                  <h3 class="card-title mb-2">
                    {{ 'note' | translate }}
                  </h3>
                </div>
                {{ purchaseOrderInfo.note }}
              </div>
            </div>
          </div>

          <div *ngIf="isEditModeEnabled" class="card">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 pr-0 pt-1">
                <form-row-input
                  [label]="'purchaseOrder.externalReference'"
                  [inputDisabled]="!isEditModeEnabled"
                  [(model)]="purchaseOrderInfo.externalReference"
                ></form-row-input>
              </div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 pr-0 pt-1">
                <form-row-select
                  [label]="'purchase.depot-to'"
                  [options]="depots"
                  [(ngModel)]="purchaseOrderInfo.depot"
                  [required]="true"
                  [isSelectDisabled]="
                    !isEditModeEnabled || (purchaseOrder?.id > 0 && purchaseOrder?.status?.id !== 'new')
                  "
                  #depot="ngModel"
                ></form-row-select>
              </div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 pr-0 pt-1">
                <form-row-select
                  [label]="'supplier'"
                  [options]="suppliers"
                  [(ngModel)]="purchaseOrderInfo.supplier"
                  [dataCyAttribute]="'supplier-select'"
                  [required]="true"
                  [isSelectDisabled]="
                    !isEditModeEnabled || (purchaseOrder?.id > 0 && purchaseOrder?.status?.id !== 'new')
                  "
                  #supplier="ngModel"
                ></form-row-select>
              </div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 pr-0">
                <form-row-textarea
                  [icon]="'far-note'"
                  [label]="'note'"
                  [rows]="1"
                  [inputDisabled]="!isEditModeEnabled"
                  [(model)]="purchaseOrderInfo.note"
                ></form-row-textarea>
              </div>
            </div>
            <div class="row" *ngIf="isEditModeEnabled && isCreationModeEnabled">
              <div class="col-12">
                <div class="d-flex align-items-center mt-1">
                  <btn
                    [icon]="'far-plus'"
                    [label]="'purchase-order.fetchUnderMinimum' | translate"
                    (onEvent)="fetchProductsUnderMinimum()"
                    [classes]="['btn', 'btn-first']"
                  ></btn>
                  <p class="m-0 ml-3 info-text">
                    {{ 'purchase-order.fetchUnderMinimum.text' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
        <div class="card" *ngIf="activeTab === 'common'">
          <p *ngIf="!productList?.length" class="text-align-center">{{ 'no.items' | translate }}</p>
          <div *ngIf="productList?.length" class="table-responsive">
            <table class="table">
              <thead>
                <tr *ngIf="isEditModeEnabled">
                  <th class="pl-0">{{ 'product.name' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'purchase.price-without-vat' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'purchase.price-with-vat' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'numberOfItems' | translate }}</th>
                  <th class="text-nowrap text-right">{{ 'purchase.price-total-row' | translate }}</th>
                  <th *ngIf="!isCreationModeEnabled" class="text-nowrap text-left">{{ 'status' | translate }}</th>
                  <th></th>
                </tr>
                <tr *ngIf="!isEditModeEnabled">
                  <th class="pl-0">{{ 'product.name' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'purchase.price-per-piece' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'purchase.price-per-row' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'numberOfItems' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'numberOfItems.stocked' | translate }}</th>
                  <th class="text-nowrap text-left">{{ 'status' | translate }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody *ngIf="isEditModeEnabled">
                <tr
                  *ngFor="let item of productList"
                  [ngClass]="
                    item.status?.id === 'cancelled'
                      ? 'row-cancelled'
                      : item.quantity === item.quantityIn
                        ? 'colorGrey'
                        : item.quantityIn > 0 && item.quantityIn < item.quantity
                          ? 'colorYellow'
                          : ''
                  "
                >
                  <td class="pl-1 text-left">
                    <div class="flex-gap-10 align-items-center">
                      <!--                    <div [photoGallery]="item.mainImage?.url"-->
                      <!--                         [photoGalleryCaption]="-->
                      <!--                  item.fullName + '<br>' + (item.code ?  ('product.code' | translate) + item.code : '') + '<br>' + (item.ean ? ('product.ean' | translate) + item.ean : '')"-->
                      <!--                    >-->
                      <div class="images-item">
                        <img class="images-item-image" [src]="getThumbUrl(item.mainImage)" [alt]="item.fullName" />
                      </div>
                      <!--                    </div>-->
                      <div>
                        <a class="link-bold" target="_blank" [routerLink]="['/product', item.product]">{{
                          item.name
                        }}</a>
                        <!--                      <div class="product-details flex-gap-5 flex-wrap">-->
                        <!--                        <div *ngIf="item.code && item.code.length > 0">-->
                        <!--                          {{ 'product.code' | translate }}:<span> {{ item.code }}</span>-->
                        <!--                        </div>-->
                        <!--                        <div *ngIf="item.ean && item.ean.length > 0">-->
                        <!--                          {{ 'product.ean' | translate }}:<span> {{ item.ean }}</span>-->
                        <!--                        </div>-->
                        <!--                      </div>-->
                      </div>
                    </div>
                  </td>
                  <td class="text-right" [ngClass]="isCreationModeEnabled ? 'input-156' : 'input-90'">
                    <form-row-input
                      [model]="item.purchasePrice"
                      (modelChange)="rowChange(item, 'purchasePrice', $event)"
                      [showErrorBorder]="!item.isValid"
                      [inputDisabled]="
                        !isEditModeEnabled ||
                        item.status?.id === 'stocked' ||
                        item.status?.id === 'cancelled' ||
                        item.status?.id === 'partly_stocked'
                      "
                    ></form-row-input>
                  </td>
                  <td class="text-right" [ngClass]="isCreationModeEnabled ? 'input-156' : 'input-90'">
                    <form-row-input
                      [model]="item.purchasePriceWithVat"
                      (modelChange)="rowChange(item, 'purchasePriceWithVat', $event)"
                      [showErrorBorder]="!item.isValid"
                      [inputDisabled]="
                        !isEditModeEnabled ||
                        item.status?.id === 'stocked' ||
                        item.status?.id === 'cancelled' ||
                        item.status?.id === 'partly_stocked'
                      "
                    ></form-row-input>
                  </td>
                  <td class="text-right input-70">
                    <form-row-number-with-controls
                      [model]="item.quantity"
                      [minValue]="1"
                      (modelChange)="rowChange(item, 'quantity', $event)"
                      [showErrorBorder]="!item.isValid"
                      [readonly]="
                        !isEditModeEnabled ||
                        item.status?.id === 'stocked' ||
                        item.status?.id === 'cancelled' ||
                        item.status?.id === 'partly_stocked'
                      "
                    ></form-row-number-with-controls>
                  </td>
                  <td class="text-right text-line-1">
                    <div>{{ item.purchasePriceAllWithVat | formatPrice: item.currency }}</div>
                    <div>
                      <small
                        >{{ item.purchasePriceAll | formatPrice: item.currency }} {{ 'without-vat' | translate }}</small
                      >
                    </div>
                  </td>
                  <td *ngIf="!isCreationModeEnabled" class="text-left">
                    {{ 'purchaseOrderStatus.' + item.status.id | translate }}
                  </td>
                  <td class="text-right text-nowrap">
                    <btn
                      *ngIf="
                        item.status?.id !== 'stocked' &&
                        item.status?.id !== 'partly_stocked' &&
                        item.status?.id !== 'cancelled' &&
                        isEditModeEnabled &&
                        !isCreationModeEnabled
                      "
                      [label]="'cancel' | translate"
                      [title]="'cancel' | translate"
                      [icon]="'fa-ban'"
                      [classes]="['btn-sm', 'btn-second', 'mr-2']"
                      (click)="stockUpCancel(item)"
                    ></btn>
                    <btn
                      *ngIf="item.status?.id === 'partly_stocked' && isEditModeEnabled && !isCreationModeEnabled"
                      [label]="'cancel.rest' | translate"
                      [title]="'cancel.rest' | translate"
                      [icon]="'fa-ban'"
                      [classes]="['btn-sm', 'btn-second', 'mr-2']"
                      (click)="stockUpCancelRest(item)"
                    ></btn>
                    <btn
                      *ngIf="isEditModeEnabled && isCreationModeEnabled"
                      [title]="'delete' | translate"
                      [icon]="'far-trash-alt'"
                      [classes]="['btn-sm', 'btn-trash']"
                      (click)="remove(item)"
                    ></btn>
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="!isEditModeEnabled">
                <tr
                  *ngFor="let item of productList"
                  [ngClass]="
                    item.status?.id === 'cancelled'
                      ? 'row-cancelled'
                      : item.quantity === item.quantityIn
                        ? 'colorGrey'
                        : item.quantityIn > 0 && item.quantityIn < item.quantity
                          ? 'colorYellow'
                          : ''
                  "
                >
                  <td class="pl-1 text-left">
                    <div class="flex-gap-10 align-items-center">
                      <!--                    <div [photoGallery]="item.mainImage?.url"-->
                      <!--                         [photoGalleryCaption]="-->
                      <!--                  item.fullName + '<br>' + (item.code ?  ('product.code' | translate) + item.code : '') + '<br>' + (item.ean ? ('product.ean' | translate) + item.ean : '')"-->
                      <!--                    >-->
                      <div class="images-item">
                        <img class="images-item-image" [src]="getThumbUrl(item.mainImage)" [alt]="item.fullName" />
                      </div>
                      <!--                    </div>-->
                      <div>
                        <a class="link-bold" target="_blank" [routerLink]="['/product', item.product]">{{
                          item.name
                        }}</a>
                        <!--                      <div class="product-details flex-gap-5 flex-wrap">-->
                        <!--                        <div *ngIf="item.code && item.code.length > 0">-->
                        <!--                          {{ 'product.code' | translate }}:<span> {{ item.code }}</span>-->
                        <!--                        </div>-->
                        <!--                        <div *ngIf="item.ean && item.ean.length > 0">-->
                        <!--                          {{ 'product.ean' | translate }}:<span> {{ item.ean }}</span>-->
                        <!--                        </div>-->
                        <!--                      </div>-->
                      </div>
                    </div>
                  </td>
                  <td class="text-left text-line-1">
                    <div>{{ item.purchasePriceWithVat | formatPrice: item.currency }}</div>
                    <div>
                      <small
                        >{{ item.purchasePrice | formatPrice: item.currency }} {{ 'without-vat' | translate }}</small
                      >
                    </div>
                  </td>
                  <td class="text-left text-line-1">
                    <div>{{ item.purchasePriceWithVat * item.quantity | formatPrice: item.currency }}</div>
                    <div>
                      <small
                        >{{ item.purchasePrice * item.quantity | formatPrice: item.currency }}
                        {{ 'without-vat' | translate }}</small
                      >
                    </div>
                  </td>
                  <td class="text-left">
                    <div>{{ item.quantity }}</div>
                  </td>
                  <td class="text-left">
                    <div>{{ item.quantityIn }}</div>
                  </td>
                  <td class="text-left">
                    {{ 'purchaseOrderStatus.' + item.status.id | translate }}
                  </td>
                  <td class="text-right text-nowrap">
                    <btn
                      *ngIf="item.status?.id !== 'stocked' && item.status?.id !== 'cancelled'"
                      [label]="'stock.up' | translate"
                      [title]="'stock.up' | translate"
                      [icon]="'far-layer-plus'"
                      [classes]="['btn-sm', 'btn-second']"
                      (click)="stockUp(item)"
                    ></btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex flex-row justify-content-between row align-items-center">
            <div class="col-8">
              <modal-product-search-purchase
                *ngIf="isEditModeEnabled"
                (chosenProduct)="addProduct($event)"
              ></modal-product-search-purchase>
            </div>
            <div class="col-4 d-flex flex-row justify-content-end">
              <div class="price-box">
                <table>
                  <tr>
                    <td>{{ 'price.sum.without.vat' | translate }}</td>
                    <td class="text-right">{{ priceSum | formatPrice: purchaseCurrencyFromCompany }}</td>
                  </tr>
                  <tr>
                    <td>{{ 'price.vat' | translate }}</td>
                    <td class="text-right">
                      {{ priceWithVatSum - priceSum | formatPrice: purchaseCurrencyFromCompany }}
                    </td>
                  </tr>
                  <tr class="text-primary text-bold">
                    <td>{{ 'price.sum.with.vat' | translate }}</td>
                    <td class="text-right">{{ priceWithVatSum | formatPrice: purchaseCurrencyFromCompany }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="info-text-price d-flex align-items-center mr-0">
            <p class="m-0">
              {{ 'price.info-text-1' | translate }}
              <br />
              {{ 'price.info-text-2' | translate }}
            </p>
            <i class="fal fa-info-circle"></i>
          </div>
        </div>
        <div *ngIf="!isCreationModeEnabled && activeTab === 'pmps'" class="">
          <app-base-listing
            [storageKey]="storageKey"
            [loadingNextItems]="loading"
            [loadingItems]="reloading"
            [items]="productMovePacks"
            [columns]="listingColumns"
            [totalItems]="totalItems"
            [currentPage]="currentPage"
            [endPage]="endPage"
            [(sortProp)]="sortProp"
            [(sortDir)]="sortDir"
            (reloadList)="filter()"
            (switchPage)="filter($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
            (callAction)="callAction($event)"
          ></app-base-listing>
        </div>
      </div>
    </div>
  </section>
  <modal-qrcode #modalQr></modal-qrcode>
</div>
